import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  itcSummaryReport: {},
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
